// extracted by mini-css-extract-plugin
export default {"wrapper":"_34e3a024","link":"_f2599217"};